import { Collapse } from 'antd'
import styled from 'styled-components'

export const Panel = styled(Collapse.Panel)`
  .ant-collapse-header {
    background-color: white !important;
    border-radius: 9px 9px 0 0 !important;
  }
`
